module.exports = __webpack_public_path__ + "static/Paypal-Spenden-Button-6de617be900f93bd8e70cb8d1af8adb1.png";